import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function AboutPage() {
  const {
    t,
    language
  } = useLanguage();
  const isHebrew = language === 'he';
  return <div className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12" data-id="element-72" data-mp="54s6sdjyswpo">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-white rounded-lg shadow-md p-6 md:p-12" data-id="element-73" data-mp="6yzfh6xdwnt">
        <h1 className="text-3xl md:text-5xl font-bold mb-6 md:mb-8 text-[#2A4B7C]" data-id="element-74" data-mp="3mcvyabx0mhp1">
          {t.about.title}
        </h1>
        <div className="prose prose-lg max-w-none" data-id="element-75" data-mp="3icviony6k0ge">
          <p className="text-lg text-[#334E68]" data-id="element-76" data-mp="3ddip7kcszv4u">{t.about.content}</p>
        </div>

        <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-gray-200" data-id="element-77" data-mp="1gkyx0liata7w">
          <div className="grid md:grid-cols-3 gap-8 text-center" data-id="element-78" data-mp="1giw9c84mbt6c">
            <div data-id="element-79" data-mp="1bn771x17ry6c">
              <h3 className="text-3xl font-bold mb-2 text-[#2A4B7C]" data-id="element-80" data-mp="1bmnnycztv3qq">2</h3>
              <p className="font-[700] text-[#2A4B7C]" data-id="element-81" data-mp="2ev62v92ko8ir">
                {isHebrew ? 'הוצאות' : 'Issues Published'}
              </p>
            </div>
            <div data-id="element-82" data-mp="2jsxyoe6c8es8">
              <h3 className="text-3xl font-bold mb-2 text-[#2A4B7C]" data-id="element-83" data-mp="25vswip9qw029">10+</h3>
              <p className="font-[700] text-[#2A4B7C]" data-id="element-84" data-mp="25xvubvh52xhj">
                {isHebrew ? 'אנשים בצוות' : 'Team Members'}
              </p>
            </div>
            <div data-id="element-85" data-mp="2yl9lfcy5oytq">
              <h3 className="text-3xl font-bold mb-2 text-[#2A4B7C]" data-id="element-86" data-mp="2ykq8kand50mk">2026</h3>
              <p className="font-[700] text-[#2A4B7C]" data-id="element-87" data-mp="32kqpc1xxpnws">
                {isHebrew ? 'נוסד ב' : 'Founded'}
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}